$(document).ready(function() {
	if(!document.querySelector('.GPC0115')) return false;

	var $obj = $('.GPC0115');
	$obj.each(function() {
		if($(this).find('.carousel-box .list-box .items .item').length>0) { // do not modify
			var $slick = $(this).find('.carousel-box .list-box .items').slick({
				infinite: false,
				listStyle: true,
				slidesToShow: 6,
				slidesToScroll: 1,
				arrows : true,
				dots: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							autoplay: false,
							slidesToShow: 5,
							slidesToScroll: 1,
							arrows : true
						}
					},
					{
						breakpoint: 992,
						settings: {
							autoplay: false,
							slidesToShow: 3,
							slidesToScroll: 1,
							arrows : true
						}
					},
					{
						breakpoint: 768,
						settings: {
							autoplay: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false
						}
					}
				],
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext // common.js variable
			});
		}
	});
	// 20200406 START 이상현 - tab ui의 관계 정보 추가
	var addAriaRelationship = function(tg){
		if($(tg).find('.js-tab').length > 0){
			$(tg).find('.js-tab').find('[role="tab"]').each(function(idx) {
				$(this).attr('id', 'tabLabel_' + (idx+1));
				$(tg).find('[role="tabpanel"]').eq(idx).attr('aria-labelledby', 'tabLabel_' + (idx+1));
			});
		}
	}
	addAriaRelationship($obj);
	// 20200406 END 
});
